/**
 * One switch for the whole app: with `VITE_USE_MOCKS` unset or anything but "false", every hook
 * resolves from `src/mocks/` (in-memory, with a small delay so skeletons are visible). Set
 * `VITE_USE_MOCKS=false` (and optionally `VITE_API_BASE`) to talk to the real API.
 */
// Production builds never use mocks; dev uses them unless VITE_USE_MOCKS=false.
export const USE_MOCKS = !import.meta.env.PROD && (import.meta.env.VITE_USE_MOCKS ?? "true") !== "false";

/** API origin; empty = same origin (nginx proxies /api in production, Vite proxies it in dev). */
export const API_BASE: string = import.meta.env.VITE_API_BASE ?? "";

/**
 * Optional image host for the banner embed code, mirroring the API's `/uploads/` (e.g.
 * `https://cdn.example.ir/uploads`). Must not be a mizbanfa.net host (see KitPage
 * `embedImageSrc`); empty = partners host the downloaded file themselves.
 */
export const BANNER_CDN_BASE: string = import.meta.env.VITE_BANNER_CDN_BASE ?? "";

/** Simulated network latency for mocks (ms). */
export const MOCK_DELAY_MS = 450;
